var _rect, _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiderPositionMainPeriod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 72,
    viewBox: "0 0 49 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.3509,
    y: 30,
    width: 3.4386,
    height: 39.4286,
    rx: 1.7193,
    fill: "#FF8A29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 23,
    fill: "#FF8A29",
    stroke: "#DB7723",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1184 36.4629C14.7215 36.4629 13.5341 35.9754 12.5562 35.0004C11.5784 34.0254 11.0895 32.8414 11.0895 31.4486H7.73684V26.4343C7.73684 24.5957 8.3934 23.0218 9.70651 21.7125C11.0196 20.4032 12.5982 19.7486 14.4421 19.7486H21.1474V28.1057H27.0145L32.8816 20.835V16.4057H27.8526V13.0629H32.8816C33.8036 13.0629 34.5928 13.3902 35.2494 14.0448C35.9059 14.6995 36.2342 15.4864 36.2342 16.4057V22.005L28.6908 31.4486H21.1474C21.1474 32.8414 20.6584 34.0254 19.6806 35.0004C18.7027 35.9754 17.5153 36.4629 16.1184 36.4629ZM16.1184 33.12C16.5934 33.12 16.9915 32.9598 17.3128 32.6395C17.6341 32.3191 17.7947 31.9221 17.7947 31.4486H14.4421C14.4421 31.9221 14.6027 32.3191 14.924 32.6395C15.2453 32.9598 15.6435 33.12 16.1184 33.12ZM12.7658 18.0771V14.7343H21.1474V18.0771H12.7658ZM36.2342 36.4629C34.8373 36.4629 33.6499 35.9754 32.672 35.0004C31.6942 34.0254 31.2053 32.8414 31.2053 31.4486C31.2053 30.0557 31.6942 28.8718 32.672 27.8968C33.6499 26.9218 34.8373 26.4343 36.2342 26.4343C37.6311 26.4343 38.8185 26.9218 39.7964 27.8968C40.7742 28.8718 41.2632 30.0557 41.2632 31.4486C41.2632 32.8414 40.7742 34.0254 39.7964 35.0004C38.8185 35.9754 37.6311 36.4629 36.2342 36.4629ZM36.2342 33.12C36.7092 33.12 37.1073 32.9598 37.4286 32.6395C37.7499 32.3191 37.9105 31.9221 37.9105 31.4486C37.9105 30.975 37.7499 30.578 37.4286 30.2577C37.1073 29.9373 36.7092 29.7771 36.2342 29.7771C35.7593 29.7771 35.3611 29.9373 35.0398 30.2577C34.7185 30.578 34.5579 30.975 34.5579 31.4486C34.5579 31.9221 34.7185 32.3191 35.0398 32.6395C35.3611 32.9598 35.7593 33.12 36.2342 33.12ZM11.0895 28.1057H17.7947V23.0914H14.4421C13.5201 23.0914 12.7309 23.4187 12.0743 24.0734C11.4177 24.728 11.0895 25.515 11.0895 26.4343V28.1057Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5263,
    height: 33.4286,
    fill: "white",
    transform: "translate(7.73684 7.71428)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderPositionMainPeriod);
export default __webpack_public_path__ + "static/media/rider-position-main-period.18c79dcd205c69e6840d4a0f08116253.svg";
export { ForwardRef as ReactComponent };